import { QuoteBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import IconQuote from "../icons/IconQuote";
import { resolveImageUrl, resolveSectionClasses } from "@/storyblok/resolvers";

export default function Quote({ data }: { data: QuoteBlockData }) {
  return (
    <section
      className="section--quote"
      {...makeEditable(data)}
      id={data.anchor}
      style={{
        "--color-background": data.background_color?.color,
      }}
    >
      <div className={resolveSectionClasses(data, "container")}>
        {data.image.filename && (
          <div className="col image-container">
            <img
              src={resolveImageUrl(data.image, { width: 350 })}
              alt={data.image.alt}
              className="quote-image"
            />
          </div>
        )}
        <div className="col content-container">
          <IconQuote />
          <h3 className="content-paragraph">{data.quote}</h3>
          {data.button && (
            <div className="btn_row" {...makeEditable(data.button)}>
              <a href={`#${data.button.anchor}`} className="btn">
                {data.button.label}
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
